import './App.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Card from './components/Card';
import Footer from './components/Footer';
import About from './components/About';
import Partners from './components/Partners';
import Programs from './pages/Programs';
import SuccessStories from './pages/SuccessStories';
import News from './pages/News';
import Contact from './pages/Contact';
import Space from './pages/Space';
import Framework from './pages/Framework';
import PressConference from './pages/PressConference';
import MediaRelations from './pages/MediaRelations';
import { ROUTES } from './routes';

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Card />
      <Partners />
    </>
  );
}

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path={ROUTES.home} element={<HomePage />} />
        <Route path={ROUTES.programs} element={<Programs />} />
        <Route path={ROUTES.successStories} element={<SuccessStories />} />
        <Route path={ROUTES.space} element={<Space />} />
        <Route path={ROUTES.framework} element={<Framework />} />
        <Route path={ROUTES.mediaRelations} element={<MediaRelations />} />
        <Route path={ROUTES.pressConference} element={<PressConference />} />
        <Route path={ROUTES.news} element={<News />} />
        <Route path={ROUTES.contact} element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
